<template>
  <div class="tw-mb-8 tw-flex tw-items-center tw-justify-between">
    <div>
      <h2 class="tw-font-outfit tw-text-2xl tw-font-semibold">{{ title }}</h2>
    </div>
    <div>
      <img :src="logoUrl" alt="Logo" class="tw-h-auto tw-max-h-[32px] tw-max-w-[140px]" />
    </div>
  </div>
</template>

<script setup lang="ts">
const branding = useBrand()

defineProps<{
  title: string
}>()

const logoUrl = computed(() => {
  return branding.value.svgLogoUrl || branding.value.pngLogoUrl
})
</script>
